import { render } from "./TrainerItem.vue?vue&type=template&id=c6c72778&scoped=true"
import script from "./TrainerItem.vue?vue&type=script&lang=ts"
export * from "./TrainerItem.vue?vue&type=script&lang=ts"

import "./TrainerItem.vue?vue&type=style&index=0&id=c6c72778&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c6c72778"

export default script